import { useRef } from "react";

/**
 * Detects and removes phantom history entries pushed beyond a baseline.
 * Records history.length at mount, and when `cleanup` is called, navigates
 * back by the number of extra entries and consolidates via replaceState.
 * Useful for any third-party embed (iframes, redirects, etc.) that adds
 * unexpected history entries.
 */
const usePhantomHistoryCleanup = () => {
    const baseHistoryLengthRef = useRef<number>(window.history.length);

    const cleanup = () => {
        const extraEntries = window.history.length - baseHistoryLengthRef.current;
        if (extraEntries <= 0) return;

        const handlePopState = () => {
            window.removeEventListener('popstate', handlePopState);
            window.history.replaceState(window.history.state, '');
        };

        window.addEventListener('popstate', handlePopState);
        window.history.go(-extraEntries);
    };

    return cleanup;
};

export default usePhantomHistoryCleanup;
